import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrHelper } from '../../../helpers/toastr.helper';
import { Community } from '../../../models/identity/community.model';
import { ProjectAttendee } from '../../../models/projects/project-attendee.model';
import { Project } from '../../../models/projects/project.model';
import { CommunityService } from '../../../services/identity/community.service';
import { ProjectsService } from '../../../services/projects/projects.service';
import { ImageService } from '../../../services/shared/image.service';
import { CurrentThemeStore } from '../../../stores/current-theme.store';

@Component({
    selector: 'app-public-project',
    templateUrl: './public-project.component.html',
    styleUrls: ['./public-project.component.scss'],
})
export class PublicProjetComponent implements OnInit {
    constructor(
        private readonly route: ActivatedRoute,
        private readonly projectsService: ProjectsService,
        public imageService: ImageService,
        private translate: TranslateService,
        private themeStore: CurrentThemeStore,
        private communityService: CommunityService,
        private readonly toastrHelper: ToastrHelper,
        private readonly router: Router,
    ) {}

    public projectId: string;
    public owner: ProjectAttendee;
    public numberOfParticipant = 0;
    public project: Project;

    public primaryCommunity: Community;

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            const id = params.get('id');
            if (!id) {
                this.router.navigate(['/']);
                return;
            }
            this.projectId = id;
            this.loadProjectData();
        });
    }

    private loadProjectData(): void {
        this.projectsService.getPublicProject(this.projectId).subscribe(
            (response) => {
                if (!response) {
                    const message = this.translate.instant('projects.pages.public.projectNotFound');
                    this.toastrHelper.showError(message);
                    this.router.navigate(['/']);
                    return;
                }
                this.handleProjectResponse(response);
            },
            () => {
                const message = this.translate.instant('projects.pages.public.projectNotPublic');
                this.toastrHelper.showError(message);
                this.router.navigate(['/']);
            },
        );
    }

    private handleProjectResponse(response: any): void {
        this.project = response;
        this.numberOfParticipant = response.attendees ? response.attendees.length : 0;

        if (!response.owner) {
            return;
        }

        this.loadCommunityData(response.communityThemeId);
    }

    private loadCommunityData(ownerId: string): void {
        this.communityService.getPrimanryCommunityByUserId(ownerId).subscribe((com) => {
            if (!com) {
                return;
            }
            this.themeStore.currentCommunityId = com.id;
            this.primaryCommunity = com;
        });
    }
}
